
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.772 2v4.667c0 2.6 1.977 4.666 4.465 4.666 2.488 0 4.465-2.066 4.465-4.666V2c0-.4-.255-.667-.638-.667-.382 0-.637.267-.637.667v4.667c0 1.866-1.404 3.333-3.19 3.333s-3.19-1.467-3.19-3.333V2c0-.4-.255-.667-.637-.667-.383 0-.638.267-.638.667zm-.638 11.333H13.34c.383 0 .638.267.638.667s-.255.667-.638.667H3.134c-.383 0-.638-.267-.638-.667s.255-.667.638-.667z","fill":"#000"}})])
          )
        }
      }
    